import { IMenuActivity } from '../../../../Menu/Store/IMenuActivity'
import { IExtraActivity } from '../../../../ExtraActivity/Client/IExtraActivity'

export const isSelectAPerson = (
  activities: IMenuActivity[] | IExtraActivity[]
): boolean => activities.some((activity) => activity.isPersonSelectable)
